function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.72913 21.0051C7.00527 21.0051 7.22913 21.229 7.22913 21.5051V23.6754C7.22913 24.8719 8.19919 25.8419 9.39569 25.8419H14.716C14.9921 25.8419 15.216 26.0658 15.216 26.3419C15.216 26.6181 14.9921 26.8419 14.716 26.8419H9.39569C7.6469 26.8419 6.22913 25.4241 6.22913 23.6754V21.5051C6.22913 21.229 6.45298 21.0051 6.72913 21.0051Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.9115 21.3333C2.9115 21.0571 3.13536 20.8333 3.4115 20.8333H15.9987C16.2748 20.8333 16.4987 21.0571 16.4987 21.3333C16.4987 21.6094 16.2748 21.8333 15.9987 21.8333H3.4115C3.13536 21.8333 2.9115 21.6094 2.9115 21.3333Z",
  fill: "#0055FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.02087 17.9934C1.02087 17.7173 1.24473 17.4934 1.52087 17.4934H6.7004C6.97654 17.4934 7.2004 17.7173 7.2004 17.9934C7.2004 18.2696 6.97654 18.4934 6.7004 18.4934H1.52087C1.24473 18.4934 1.02087 18.2696 1.02087 17.9934Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.55725 14.655C2.55725 14.3789 2.78111 14.155 3.05725 14.155H10.4041C10.6803 14.155 10.9041 14.3789 10.9041 14.655C10.9041 14.9312 10.6803 15.155 10.4041 15.155H3.05725C2.78111 15.155 2.55725 14.9312 2.55725 14.655Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.94775 5.42208C8.44596 4.25617 9.5917 3.5 10.8597 3.5H23.9317C25.1997 3.5 26.3454 4.25617 26.8436 5.42209L28.3076 8.848L28.3077 8.84811C28.4756 9.24137 28.5622 9.66465 28.5622 10.0925V14.0003C28.5622 14.2765 28.3384 14.5003 28.0622 14.5003C27.7861 14.5003 27.5622 14.2765 27.5622 14.0003V10.0925C27.5622 9.79971 27.503 9.51006 27.3881 9.24096C27.3881 9.24092 27.388 9.24089 27.388 9.24085L25.9241 5.81503C25.5832 5.01743 24.7994 4.5 23.9317 4.5H10.8597C9.99199 4.5 9.20813 5.01743 8.86731 5.81503L7.40335 9.24085C7.40334 9.24089 7.40332 9.24092 7.4033 9.24096C7.2884 9.51006 7.22913 9.79971 7.22913 10.0925V14.6666C7.22913 14.9427 7.00527 15.1666 6.72913 15.1666C6.45298 15.1666 6.22913 14.9427 6.22913 14.6666V10.0925C6.22913 9.66465 6.31576 9.24138 6.4837 8.84811L7.94775 5.42208C7.94775 5.42208 7.94775 5.42208 7.94775 5.42208Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3959 3.5C17.672 3.5 17.8959 3.72386 17.8959 4V9.92608C17.8959 10.2022 17.672 10.4261 17.3959 10.4261C17.1197 10.4261 16.8959 10.2022 16.8959 9.92608V4C16.8959 3.72386 17.1197 3.5 17.3959 3.5Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.24817 10.4258C8.13299 10.4258 7.22913 11.3299 7.22913 12.4448C7.22913 12.721 7.00527 12.9448 6.72913 12.9448C6.45298 12.9448 6.22913 12.721 6.22913 12.4448C6.22913 10.7777 7.58062 9.42578 9.24817 9.42578H25.5355C27.2027 9.42578 28.5546 10.7773 28.5546 12.4448C28.5546 12.721 28.3307 12.9448 28.0546 12.9448C27.7784 12.9448 27.5546 12.721 27.5546 12.4448C27.5546 11.3296 26.6505 10.4258 25.5355 10.4258H9.24817Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5 21.3333C15.5 17.3752 18.7085 14.1667 22.6666 14.1667C26.6246 14.1667 29.8331 17.3752 29.8331 21.3333C29.8331 25.2914 26.6246 28.4999 22.6666 28.4999C19.8608 28.4999 17.4326 26.8873 16.2564 24.5411C16.1326 24.2942 16.2324 23.9938 16.4793 23.87C16.7261 23.7463 17.0266 23.846 17.1503 24.0929C18.1636 26.114 20.2537 27.4999 22.6666 27.4999C26.0723 27.4999 28.8331 24.7391 28.8331 21.3333C28.8331 17.9275 26.0723 15.1667 22.6666 15.1667C19.2608 15.1667 16.5 17.9275 16.5 21.3333C16.5 21.6094 16.2761 21.8333 16 21.8333C15.7239 21.8333 15.5 21.6094 15.5 21.3333Z",
  fill: "#0055FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9844 18.4036C22.2605 18.4036 22.4844 18.6274 22.4844 18.9036V20.915L25.8088 19.8452C26.0717 19.7606 26.3533 19.9051 26.4379 20.168C26.5225 20.4309 26.378 20.7125 26.1151 20.7971L22.1375 22.0771C21.9854 22.1261 21.8191 22.0994 21.6899 22.0053C21.5608 21.9111 21.4844 21.761 21.4844 21.6012V18.9036C21.4844 18.6274 21.7082 18.4036 21.9844 18.4036Z",
  fill: "#0055FF"
});

function SvgLoggiExpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = React.forwardRef(SvgLoggiExpress);
export default __webpack_public_path__ + "static/media/loggi-express.18fe0fa1.svg";
export { ForwardRef as ReactComponent };